import { render, staticRenderFns } from "./ClientInsurance.vue?vue&type=template&id=7281468c"
import script from "./ClientInsurance.vue?vue&type=script&lang=js"
export * from "./ClientInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports